import { WearableEligibilitySection } from 'journey/productDetails/typings';

export const getProgressionIndicatorValues = (
  currentSectionId: string,
  sections: WearableEligibilitySection[],
  minimumProgression: number = 0,
) => {
  const currentSection =
    sections.find((section) => section.value === currentSectionId) ||
    sections[0];
  const currentIndex = sections.find(
    ({ value }) => currentSectionId === value,
  )?.id;

  const stepProgression = (currentIndex / sections.length) * 100;

  if (stepProgression <= 0) {
    return { currentSection, stepProgression: minimumProgression };
  }

  return { currentSection, stepProgression };
};
